import React, { FC, useState } from "react";
import styles from "./FlightGuests.module.scss";
import Counter from "../../Counter/Counter";
import { useConfig } from "@/context/ConfigContext";
import { useTranslations } from "next-intl";
import { Passengers } from "../../Fields/selectFields/FlightGuestsField/FlightGuestsField";

interface GuestsProps {
  onApply: (passengers: Passengers) => void;
  passengers: Passengers;
  onClose: () => void;
  hideDescription?:boolean
}

const FlightGuests: FC<GuestsProps> = ({
  onApply,
  passengers: guestsData,
  onClose,
  hideDescription
}) => {
  const { config } = useConfig();
  const t = useTranslations("guests");

  const limits = {
    max_adults: config.config.limits?.flights_max_adult,
    min_adults: config.config.limits?.room_adults_min,
    max_children: config.config.limits?.flights_children_max,
    min_children: config.config.limits?.room_children_min,
    max_infants:config.config.limits?.flights_infants_max,
  };

  const [passengerData, setPassengerData] = useState<Passengers>(guestsData);

  const updateAndApply = (updatedGuestData: Passengers) => {
    setPassengerData(updatedGuestData);
    onApply(updatedGuestData);
  };

   const updateGuestData = (adults: number, children: number  , infants:number) => {
    const updatedData = {
      adults,
      children,
      infants
    };
    updateAndApply(updatedData);
  };



  const handleApply = () => {
    onApply(passengerData);
    onClose();
  };

  return (
  
<div className={`${!hideDescription && styles.FlightGuests}`} data-testid="FlightGuests">
  <div className={styles.roomHeader}>
    <p className={styles.roomApplytext}>{t("")}</p>
    <span
      className={styles.roomApplytext}
      onClick={handleApply}
      role="button"
      tabIndex={0}
      aria-label="Apply for this room"
    >
      {t("apply")}
    </span>
  </div>

  <div className={styles.counters}>
    <div className={styles.counterItem}>
      <Counter
        title={t("adults")}
        count={passengerData.adults}
        disableIncrement={
           passengerData.adults == limits.max_adults
        }
        disableDecrement={passengerData.adults <= limits.min_adults }
        onDecrease={() => updateGuestData(passengerData.adults - 1, passengerData.children, passengerData.infants)}
        onIncrease={() => updateGuestData(passengerData.adults + 1, passengerData.children, passengerData.infants)}
      />
      <div className={styles.ageRange}>16+ years</div>
    </div>

    <div className={styles.counterItem}>
      <Counter
        title={t("children")}
        count={passengerData.children}
        disableIncrement={
          passengerData.children >= limits.max_children 
        }
        disableDecrement={passengerData.children == 0}
        onDecrease={() => updateGuestData(passengerData.adults, passengerData.children - 1, passengerData.infants)}
        onIncrease={() =>
          updateGuestData(
            passengerData.adults,
            passengerData.children + 1,
            passengerData.infants
          )
        }
      />
      <div className={styles.ageRange}>2–11 years</div>
    </div>

    <div className={styles.counterItem}>
      <Counter
        title={t("infants")}
        count={passengerData.infants}
        disableIncrement={
          passengerData.infants >= limits.max_infants 
        }
        disableDecrement={passengerData.infants == 0}
        onDecrease={() => updateGuestData(passengerData.adults, passengerData.children, passengerData.infants - 1)}
        onIncrease={() => updateGuestData(passengerData.adults, passengerData.children, passengerData.infants + 1)}
      />
      <div className={styles.ageRange}>0–2 years</div>
    </div>
  </div>
{!hideDescription && 
  <div className={styles.paxListMessage}>
    <p>Your age at time of travel must be valid for the age category booked. Airlines have restrictions on under 18s travelling alone.</p>
    <p>Age limits and policies for travelling with children may vary so please check with the airline before booking.</p>
  </div>
}
</div>
      
    
  );
};

export default FlightGuests;
